/* eslint-disable compat/compat */
import validatePhone from '../helpers/validate-phone';
import validateTime from '../helpers/validate-time';
import formatPhone from '../helpers/format-E164';

export default function callbackForms() {
  const
    callblocks = document.querySelectorAll( '.call-block__callback[data-form-id]' );
  callblocks.forEach( callblock => {
    const token = callblock.dataset.formId;

    if ( token ) {
      const
        submit = callblock.querySelector( 'button[name="call-block__submit"]' ),
        phone = callblock.querySelector( 'input[name="call-block__phone"]' ),
        day = callblock.querySelector( 'select[name="call-block__day"]' ),
        hour = callblock.querySelector( 'select[name="call-block__hour"]' ),
        country = document.querySelector( 'meta[property="og:country_name"]' ).content;

      if ( day && hour ) {
        day.addEventListener( 'change', event => {
          validateTime( event.target )
        });

        hour.addEventListener( 'change', event => {
          validateTime( event.target )
        });
      }

      phone.addEventListener( 'blur', event => {
        validatePhone( event.target, country )
      })

      phone.addEventListener( 'focus', event => {
        const parent = event.target.parentElement.parentElement;
        parent.classList.remove( 'form-group--has-danger' );
        parent.classList.remove( 'form-group--has-success' );
      })

      submit.addEventListener( 'click', event => {
        event.preventDefault();
        const toValidate = [];
        let isValid = true;

        if ( day && hour ) {
          toValidate.push( day )
          toValidate.push( hour )
        }
        toValidate.push( phone )

        isValid = toValidate.every( field => {
          switch ( field.id ) {
          case 'call-block__day':
            return validateTime( field )
          case 'call-block__hour':
            return validateTime( field )
          case 'call-block__phone':
            return validatePhone( field, country )
          }
        })

        if ( isValid ) {
          if ( day && hour ) {
            submitCallback( callblock, submit, token, country, phone.value, day.value, hour.value );
          } else {
            submitCallback( callblock, submit, token, country, phone.value );
          }
        }
      })
    }
  })
}

function submitCallback( callblock, submitBtn, token, country, phone, day, hour ) {
  submitBtn.disabled = true;
  let
    data = {};

  const
    baseUrl = callblock.dataset.action,
    timeStamp = document.getElementById( 'call-block__timestamp' ).value,
    url = `${ baseUrl }?form-id=${ token }&t=${timeStamp}`,
    callbackBlock = callblock.closest( '[data-block-id]' ),
    errorMsg = callblock.querySelector( 'small.form-group__msg--danger' ),
    successMsg = callblock.querySelector( 'small.form-group__msg--success' );

  if ( day && hour ) {
    data.scheduled_at = `${ day }T${ hour }`;
  }

  data.phone = formatPhone( phone, country );
  data.block_id = callbackBlock.dataset.blockId;

  fetch( url, {
    method: 'POST',
    mode: 'cors',
    body: JSON.stringify( data ),
    headers: {
      'Content-Type': 'application/json'
    }
  }).then( response => {
    if ( response.status === 200 ) {
      return response.json();
    }
    manageFetchError( new TypeError( `Response: ${ response.status } ` ));
  }).then( json => {
    if ( json ) {
      if ( json.status === 200 ) {
        errorMsg.classList.add( 'u-display--none' );
        successMsg.classList.remove( 'u-display--none' );
        submitBtn.disabled = false;
        return;
      } else {
        console.error( 'Callback API: ', json.error )
      }
    }
    console.error( 'Callback module error' )
    successMsg.classList.add( 'u-display--none' );
    errorMsg.classList.remove( 'u-display--none' );
    submitBtn.disabled = false;
  }).catch(() => {
    manageFetchError
    submitBtn.disabled = false;
  });
}

function manageFetchError( error ) {
  console.error( error );
}

